// Conteúdo editável da landing.
// ATENÇÃO: os dados marcados como FICTÍCIO são placeholders do modelo de design
// e precisam ser trocados pelos reais antes de divulgar o site.

// FICTÍCIO: veículos da faixa "Visto em".
// `logo` é opcional: com ele o texto vira imagem (ex.: "/images/midia/folha.svg").
export const MEDIA_OUTLETS = [
  { name: "Veículo 1", href: "#", logo: null },
  { name: "Veículo 2", href: "#", logo: null },
  { name: "Veículo 3", href: "#", logo: null },
  { name: "Veículo 4", href: "#", logo: null },
  { name: "Veículo 5", href: "#", logo: null },
];

// FICTÍCIO: números da seção "Resultados".
export const STATS = [
  { label: "Cirurgiões", value: 15, suffix: "+", description: "de todas as especialidades cirúrgicas" },
  { label: "Pedidos", value: 200, suffix: "+", description: "pedidos cirúrgicos gerados" },
  { label: "Pacotes", value: 30, suffix: "+", description: "pacotes de OPME salvos" },
  { label: "Tempo", value: 6, suffix: "h", description: "economizadas por semana, por cirurgião" },
];

// FICTÍCIO: depoimento em destaque (com foto).
export const FEATURED_TESTIMONIAL = {
  quote:
    "Eu perdia uma tarde inteira por semana com pedido e OPME. Hoje resolvo tudo entre um paciente e outro.",
  name: "Dr. Rafael Menezes",
  role: "Otorrinolaringologista, Campinas SP",
  photo: "/images/depoimento-destaque.webp",
  photoAlt: "Cirurgião com lupa cirúrgica durante procedimento",
  stamp: "Antes: 4h",
};

// FICTÍCIO: depoimentos do carrossel.
export const TESTIMONIALS = [
  {
    quote: "Minhas negativas caíram pela metade. Quando vem glosa, o recurso técnico sai pronto em minutos.",
    name: "Dra. Camila Ferraz",
    role: "Ortopedista, São Paulo SP",
  },
  {
    quote: "Montei meus pacotes de OPME uma vez e nunca mais digitei código de material.",
    name: "Dr. Thiago Albuquerque",
    role: "Cirurgião geral, Rio de Janeiro RJ",
  },
  {
    quote: "Dito o histórico entre uma cirurgia e outra. Quando saio do centro cirúrgico, o pedido está pronto.",
    name: "Dra. Juliana Prado",
    role: "Ginecologista, Belo Horizonte MG",
  },
  {
    quote: "Minha secretária usa comigo. Padronizou o fluxo cirúrgico da clínica e acabou o retrabalho.",
    name: "Dr. Eduardo Kowalski",
    role: "Urologista, Curitiba PR",
  },
];

// FICTÍCIO: redes sociais do rodapé (o WhatsApp é adicionado a partir de WHATSAPP_URL).
export const SOCIAL_LINKS = [
  { label: "Instagram", href: "https://www.instagram.com/letsdoc.ai/" },
  { label: "LinkedIn", href: "#" },
  { label: "YouTube", href: "#" },
];

// Dados da empresa no rodapé. O CNPJ é o mesmo dos Termos de Uso (src/Pages/Terms/TermsPage.jsx).
export const COMPANY = {
  legalName: "LetsDoc Tecnologia Ltda.",
  cnpj: "60.572.889/0001-03",
  copyright: "© 2024 a 2026 LetsDoc.",
  supportEmail: "suporte@letsdoc.ai",
};

export const FAQ = [
  {
    question: "O LetsDoc é para qual especialidade?",
    answer:
      "Para todas as especialidades cirúrgicas. Ortopedia, urologia, otorrino, ginecologia, cirurgia geral, plástica, vascular e outras. O LetsDoc foi pensado para a rotina de quem opera, não para a saúde em geral.",
  },
  {
    question: "Como o LetsDoc ajuda com glosas e negativas?",
    answer:
      "Em duas frentes. Primeiro, o pedido já sai fundamentado, o que reduz negativas das operadoras. Segundo, quando a glosa acontece, a plataforma gera um recurso técnico embasado e objetivo em minutos. Você revisa e envia.",
  },
  {
    question: "O recurso de glosa está em todos os planos?",
    answer:
      "Sim. Pedido cirúrgico e recurso técnico de glosa estão incluídos em todos os planos, inclusive no gratuito.",
  },
  {
    question: "O que preciso para usar o LetsDoc?",
    answer:
      "Apenas um navegador e o histórico do paciente. Não há instalação. Você cria a conta e gera o primeiro pedido em minutos.",
  },
  {
    question: "Os dados dos pacientes ficam seguros?",
    answer:
      "Sim. Seguimos a LGPD, os dados são tratados com anonimização e controle de acesso, e os áudios de transcrição não ficam armazenados.",
  },
  {
    question: "O pedido sai no padrão do meu convênio?",
    answer:
      "O pedido é gerado com CID, procedimento, justificativa e materiais estruturados. Você revisa e ajusta antes de enviar.",
  },
  {
    question: "O que são pacotes de cirurgia e OPME?",
    answer:
      "Modelos salvos com procedimentos, materiais e quantidades que você usa com frequência. Montou uma vez, reaproveita em todos os pedidos.",
  },
  {
    question: "Posso usar com minha secretária ou equipe?",
    answer:
      "Sim. O plano Empresarial oferece licenças para múltiplos profissionais e especialidades, com integrações sob demanda.",
  },
  {
    question: "Posso cancelar quando quiser?",
    answer: "Sim. Os planos são mensais e sem fidelidade. O plano Básico é gratuito para sempre.",
  },
];
